import React from "react";
import { AreaChart } from "../../../shared/Charts";
import { getProductTerminology } from "../../../constants/product-terminology";

const ClientJobChart = (props) => {
  const terms = getProductTerminology(props.appType);
  return (
    <>
      <div className="mb-3 text-xs md:text-sm uppercase text-gray-500 font-bold">
        {terms.jobPlural}
      </div>
      <AreaChart
        height={350}
        data={props.data}
        appType={props.appType}
        dataType="jobs"
      />
    </>
  );
};

export default ClientJobChart;
